// AccountSettings.jsx

import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Alert
} from "@mui/material";

import { useAuth } from "../context/AuthContext";
import config from "../twh/config";

const API_URL =
  config.reactApi_baseUrl +
  "/react-api/users/loginUser-accountSettings.php";

export default function AccountSettings() {
  const { userData } = useAuth();

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    password2: "",
  });

  const [errors, setErrors] = useState({});
  const [alertMsg, setAlertMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ INITIAL DATA SET
  useEffect(() => {
    if (userData?.userData) {
      setForm((prev) => ({
        ...prev,
        firstName: userData.userData.firstName || "",
        lastName: userData.userData.lastName || "",
        email: userData.userData.email || "",
      }));
    }
  }, [userData]);

  // handle input
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setErrors({});
    setAlertMsg(null);

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          ...form,
          issetAddEditUser: true,
        }),
      });

      const json = await res.json();

      if (json.status) {
        setAlertMsg({ type: "success", text: "Saved successfully" });
      } else {
        setErrors(json.errorMsg || {});
        setAlertMsg({ type: "error", text: "Please fix errors" });
      }
    } catch (err) {
      console.error(err);
      setAlertMsg({ type: "error", text: "Server error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item size={{ md: 12 }}>
        <Card sx={{ p: 3 }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2} justifyContent="center">
              <Grid item size={{ md: 8 }}>
                <Typography variant="h6" fontWeight={700}>
                  Account Settings
                </Typography>

                <Box sx={{ my: 2 }}>
                  <hr />
                </Box>

                {alertMsg && (
                  <Alert severity={alertMsg.type} sx={{ mb: 2 }}>
                    {alertMsg.text}
                  </Alert>
                )}

                <Grid container spacing={2}>
                  {/* First Name */}
                  <Grid item size={{ md: 6 }}>
                    <TextField
                      fullWidth
                      label="First Name"
                      name="firstName"
                      value={form.firstName}
                      onChange={handleChange}
                      error={!!errors?.firstName}
                      helperText={errors?.firstName}
                    />
                  </Grid>

                  {/* Last Name */}
                  <Grid item size={{ md: 6 }}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      name="lastName"
                      value={form.lastName}
                      onChange={handleChange}
                      error={!!errors?.lastName}
                      helperText={errors?.lastName}
                    />
                  </Grid>

                  {/* Email */}
                  <Grid item size={{ md: 12 }}>
                    <TextField
                      fullWidth
                      label="Email Address"
                      name="email"
                      type="email"
                      value={form.email}
                      onChange={handleChange}
                      error={!!errors?.email}
                      helperText={errors?.email}
                    />
                  </Grid>

                  {/* Password */}
                  <Grid item size={{ md: 6 }}>
                    <TextField
                      fullWidth
                      label="Password"
                      name="password"
                      type="password"
                      value={form.password}
                      onChange={handleChange}
                      error={!!errors?.password}
                      helperText={errors?.password}
                    />
                  </Grid>

                  {/* Password 2 */}
                  <Grid item size={{ md: 6 }}>
                    <TextField
                      fullWidth
                      label="Re-Type Password"
                      name="password2"
                      type="password"
                      value={form.password2}
                      onChange={handleChange}
                      error={!!errors?.password2}
                      helperText={errors?.password2}
                    />
                  </Grid>
                </Grid>

                {/* Submit */}
                <Box textAlign="right" mt={3}>
                  <Button type="submit" variant="contained" disabled={loading}>
                    {loading ? (
                      <CircularProgress size={20} />
                    ) : (
                      "Save Changes"
                    )}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Card>
      </Grid>
    </Grid>
  );
}